import React from 'react';
import { Save } from 'lucide-react';
import { Modal } from '../../../../../../../components/ui/Modal';
import type { Topico } from '../../../../types';

interface TopicoModalProps {
  open: boolean;
  onClose: () => void;
  editingTopico: Topico | null;
  topicoForm: { titulo: string; ordem: number };
  setTopicoForm: React.Dispatch<React.SetStateAction<{ titulo: string; ordem: number }>>;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}

export function TopicoModal({
  open,
  onClose,
  editingTopico,
  topicoForm,
  setTopicoForm,
  onSubmit,
}: TopicoModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={editingTopico ? 'Editar Módulo' : 'Novo Módulo'}
      size="default"
    >
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div>
          <label style={{ display: 'block', fontSize: '.75rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Nome do Módulo (Tópico)</label>
          <input
            type="text"
            required
            placeholder="Ex: Chamada de Classe"
            value={topicoForm.titulo}
            onChange={(e) => setTopicoForm({ ...topicoForm, titulo: e.target.value })}
            className="ecad-input-premium"
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '.75rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Ordem de Exibição</label>
          <input
            type="number"
            required
            value={topicoForm.ordem}
            onChange={(e) => setTopicoForm({ ...topicoForm, ordem: Number(e.target.value) })}
            className="ecad-input-premium"
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 10 }}>
          <button type="button" onClick={onClose} className="btn-cancel" style={{ height: 36, padding: '0 16px', fontSize: '.8rem', borderRadius: 8 }}>
            Cancelar
          </button>
          <button type="submit" className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: 6, height: 36, padding: '0 16px', fontSize: '.8rem', borderRadius: 8 }}>
            <Save size={14} /> Salvar
          </button>
        </div>
      </form>
    </Modal>
  );
}
